// Plasmic CMS configuration
// These values should be set in environment variables
const PLASMIC_CMS_ID = '5778251mmxm4Trfd1FeAyX';
const PLASMIC_CMS_PUBLIC_TOKEN =
  '3qcJI9W8MdtG1zjjkQPwr32wBazqkqIEeqsHmlbUcsjUD8fBw3UERAUQrhiJgTrU8hKoIqJhjzH5Lpd1OJDvgw';

interface PlasmicCMSResponse<T> {
  rows: {
    id: string;
    data: T;
    createdAt: string;
  }[];
}

export async function fetchPlasmicCMS<T>(tableName: string): Promise<T[]> {
  if (!PLASMIC_CMS_ID || !PLASMIC_CMS_PUBLIC_TOKEN) {
    console.warn('Plasmic CMS credentials not configured');
    return [];
  }

  try {
    const response = await fetch(
      `https://data.plasmic.app/api/v1/cms/databases/${PLASMIC_CMS_ID}/tables/${tableName}/query`,
      {
        headers: {
          'x-plasmic-api-cms-tokens': `${PLASMIC_CMS_ID}:${PLASMIC_CMS_PUBLIC_TOKEN}`,
        },
      },
    );

    if (!response.ok) {
      console.error(
        `Failed to fetch from Plasmic CMS table ${tableName}:`,
        response.statusText,
      );
      return [];
    }

    const data: PlasmicCMSResponse<T> = await response.json();
    return data.rows.map((row) => ({ ...row.data, createdAt: row.createdAt }));
  } catch (error) {
    console.error(`Error fetching from Plasmic CMS table ${tableName}:`, error);
    return [];
  }
}

export async function fetchPlasmicWinnerCMS(
  key: string,
  value: string | null | boolean,
): Promise<WinnerCmsItem[]> {
  if (!PLASMIC_CMS_ID || !PLASMIC_CMS_PUBLIC_TOKEN) {
    console.warn('Plasmic CMS credentials not configured');
    return [];
  }

  const tableName = 'winners';

  const queryJsonString = JSON.stringify({
    where: {
      [key]: value,
    },
  });

  try {
    const response = await fetch(
      `https://data.plasmic.app/api/v1/cms/databases/${PLASMIC_CMS_ID}/tables/${tableName}/query?q=${encodeURIComponent(queryJsonString)}`,
      {
        headers: {
          'x-plasmic-api-cms-tokens': `${PLASMIC_CMS_ID}:${PLASMIC_CMS_PUBLIC_TOKEN}`,
        },
      },
    );

    if (!response.ok) {
      console.error(
        `Failed to fetch from Plasmic CMS table ${tableName}:`,
        response.statusText,
      );
      return [];
    }

    const data: PlasmicCMSResponse<WinnerCmsItem> = await response.json();
    return data.rows.map((row) => ({ ...row.data, createdAt: row.createdAt }));
  } catch (error) {
    console.error(`Error fetching from Plasmic CMS table ${tableName}:`, error);
    return [];
  }
}

// Type for winnersHomepage table
export interface WinnerHomepage {
  winnerName: string;
  prizeName: string;
  createdAt: string;
  image: {
    url: string;
    width?: number;
    height?: number;
  };
}

export interface WinnerCmsItem {
  title: string;
  videoLink?: string;
  videoLinkInstagram?: string;
  photoSquare: {
    url: string;
    name: string;
  };
}

export async function fetchWinnersHomepage(): Promise<WinnerHomepage[]> {
  return fetchPlasmicCMS<WinnerHomepage>('winnersHomepage');
}

export async function fetchWinnersSpotlight(): Promise<WinnerCmsItem[]> {
  return fetchPlasmicWinnerCMS('winnersPageInSpotlight', true);
}
export async function fetchWinnersPinned(): Promise<WinnerCmsItem[]> {
  return fetchPlasmicWinnerCMS('pinned', true);
}
export async function fetchWinnersWallOfFame(): Promise<WinnerCmsItem[]> {
  return fetchPlasmicWinnerCMS('showHomePage', true);
}

export function resizePlasmicImage(url: string | undefined) {
  if (!url) {
    return undefined;
  }
  return (
    'https://img.plasmic.app/img-optimizer/v1/img?src=' +
    encodeURIComponent(url) +
    '&w=768&q=70&f=webp'
  );
}
